import React from 'react'
import {NavLink} from 'react-router-dom'

import { SiteContext } from 'context/site-context'

import { getQS } from 'helpers'

const Logo = props => {
  const [ site, setSite ] = React.useContext(SiteContext)

  return (
    <NavLink to={`/${getQS().trim().length > 0 ? `?${getQS()}` : ''}`}
      className="main-logo"
      onClick={ () => setSite({ ...site, showHeader: false }) }>
        <img src={site.logoWebP || site.logo} alt={site.domain} />
      </NavLink>
  )
}

export default Logo
